import { render, staticRenderFns } from "./PenCanvas.vue?vue&type=template&id=062984b4&scoped=true&lang=pug&"
import script from "./PenCanvas.vue?vue&type=script&lang=ts&"
export * from "./PenCanvas.vue?vue&type=script&lang=ts&"
import style0 from "./PenCanvas.vue?vue&type=style&index=0&id=062984b4&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "062984b4",
  null
  
)

export default component.exports